export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';

export const setFilterParams = data => {
  return {
    type: SET_FILTER_PARAMS,
    payload: data,
  };
};
